import React from 'react';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import Image from 'next/image';
import { imageSerializer } from '../../../utils/imageSerializer';
import { ImageFieldImage } from '@prismicio/types';
import {
  Person,
  PersonCompanyPosition,
  PersonData,
  PersonImage,
  PersonName,
  QuoteText,
  ReviewCardWrapper,
} from './reviewCard.styles';

interface IProps {
  name: Array<RichTextBlock>;
  position: Array<RichTextBlock>;
  company: Array<RichTextBlock>;
  photo: ImageFieldImage;
  quote: Array<RichTextBlock>;
}

export const ReviewCard = ({
  name,
  position,
  company,
  photo,
  quote,
}: IProps) => {
  return (
    <ReviewCardWrapper>
      <div className={'review-card__quote-icon testimonial__quote-icon'} />
      <QuoteText>{RichText.asText(quote)}</QuoteText>
      <Person>
        <PersonImage>
          <Image {...imageSerializer(photo)} className="person-image" />
        </PersonImage>
        <PersonData>
          <PersonName>{RichText.asText(name)}</PersonName>
          <PersonCompanyPosition>
            {RichText.asText(position)},{' '}
          </PersonCompanyPosition>
          <PersonCompanyPosition>
            {RichText.asText(company)}
          </PersonCompanyPosition>
        </PersonData>
      </Person>
    </ReviewCardWrapper>
  );
};
